module.exports = __webpack_public_path__ + "img/2b62350.png";